export default {
  set(state, payload) {
    state[payload[0]] = payload[1]
  },
  SET_NOTIFICATION(state, payload) {
    state.notifications = payload
  },
  SET_ALL_NOTIFICATION(state, payload) {
    state.allnotifications = payload
  },
  SET_NEW_NOTIFICATION(state, payload) {
    state.newNotifications = payload
  },
  SET_ANNOUNCEMENTS(state, payload) {
    state.announcements = payload
  },
  UPDATE_ANNOUNCEMENT(state, payload) {
    state.announcements.unshift(payload)
  },
  UPDATE_ANNOUNCEMENT_STATUS(state, payload) {
    state.announcements.forEach((announcement) => {
      if (announcement.id === payload.id) {
        announcement.status = payload.action
      }
    })
  },
  SET_NOTIFICATION_COUNT(state, payload) {
    state.notificationCount = payload
  },
  SET_UNREAD_ANNOUNCEMENTS_COUNT(state, payload) {
    if (typeof payload === 'number') {
      state.unreadAnnouncementsCount = payload
    } else if (payload === 'decrement') {
      if (state.unreadAnnouncementsCount > 0) {
        state.unreadAnnouncementsCount -= 1
      }
    } else if (payload === 'increment') {
      state.unreadAnnouncementsCount += 1
    } else {
      console.warn('Invalid payload passed to SET_UNREAD_ANNOUNCEMENTS_COUNT:', payload)
    }
  },

  SET_UNREAD_NOTIFICATIONS_COUNT(state, payload) {
    state.unreadNotifiationCount = payload
  },
}
